import { H5StockDetailPanel } from "./H5StockDetailPanel";
import "./StockDetailModal.css";

export interface StockDetailModalProps {
  open: boolean;
  stockCode: string;
  onClose: () => void;
}

/** 满屏弹框形式的股票详情，不切换路由，便于保留下层页面状态 */
export default function StockDetailModal(props: StockDetailModalProps): JSX.Element | null {
  const { open, stockCode, onClose } = props;
  const code = stockCode.trim();
  if (!open || !code) {
    return null;
  }

  return (
    <div className="lf-stock-detail-modal" role="dialog" aria-modal="true" aria-label="股票详情">
      <H5StockDetailPanel stockCode={code} onBack={onClose} />
    </div>
  );
}
